import PanelItem from "./PanelItem";

export default PanelItem;
